// What a structure save changes in the workbook: new / renamed / removed sheets and TOTALs.
// Sheets are matched by object id + row id, so a renumbered row shows as a rename.

import { workbookSheets } from "./structureRules.js";

const keyed = (site, trees, frozen) => {
  const out = new Map();
  workbookSheets(site, trees, { frozen }).forEach((obj) => {
    out.set(`${obj.objectId}:TOTAL`, { tab: obj.total, object: obj.name });
    obj.sheets.forEach((s) => out.set(`${obj.objectId}:${s.id}`, { tab: s.tab, object: obj.name }));
  });
  return out;
};

/** [{ kind: "add" | "remove" | "rename", tab, from? }] in workbook order (removals last). */
export function structureDiff(before, after) {
  const a = keyed(before.site, before.trees, before.frozen);
  const b = keyed(after.site, after.trees, after.frozen);
  const changes = [];
  b.forEach((sheet, key) => {
    const old = a.get(key);
    if (!old) changes.push({ kind: "add", tab: sheet.tab });
    else if (old.tab !== sheet.tab) changes.push({ kind: "rename", tab: sheet.tab, from: old.tab });
  });
  a.forEach((sheet, key) => {
    if (!b.has(key)) changes.push({ kind: "remove", tab: sheet.tab });
  });
  return changes;
}
